import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const ChevronDown = (props: SvgProps) => (
    <Svg width={14} height={8} {...props} fill="none">
        <Path
            stroke={props.color || ds.colorValue.icon.primary}
            strokeLinejoin="round"
            strokeWidth={1.75}
            d="m.62.62 6 6 6-6"
        />
    </Svg>
);
